export const CI_THEME = { primary: '#7B2D5E', accent: '#C08A3E', text: '#2B2629', background: '#F6F4F1' };
/** The CI palette, offered as swatches when choosing (name, hex). */
export const CI_SWATCHES = [
    { name: 'Pflaume', hex: '#7B2D5E' }, { name: 'Pflaume dunkel', hex: '#501D3D' }, { name: 'Pflaume 80', hex: '#95577E' },
    { name: 'Pflaume 60', hex: '#B0819E' }, { name: 'Pflaume 40', hex: '#CAABBF' }, { name: 'Pflaume 20', hex: '#E5D5DF' },
    { name: 'Pflaume 10', hex: '#F2EAEF' }, { name: 'Anthrazit', hex: '#2B2629' }, { name: 'Steingrau', hex: '#6E686B' },
    { name: 'Hellgrau', hex: '#D8D4D3' }, { name: 'Papier', hex: '#F6F4F1' }, { name: 'Weiß', hex: '#FFFFFF' },
    { name: 'Ocker', hex: '#C08A3E' }, { name: 'Salbei', hex: '#7E8C6E' },
];
export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;
const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const toHex = (c) => `#${c.map((v) => Math.round(Math.min(255, Math.max(0, v))).toString(16).padStart(2, '0')).join('')}`.toUpperCase();
/** `hex` mixed with `other` by `amount` (0 = hex, 1 = other). */
export function mix(hex, other, amount) {
    const a = rgb(hex);
    const b = rgb(other);
    return toHex(a.map((v, i) => v + (b[i] - v) * amount));
}
/**
 * Ten shades for the program's colour scale (lightest first), the colour
 * itself at index 6 - tints with white above, with black below, as the CI
 * derives its "Pflaume 10 … 80".
 */
export function shades(hex) {
    const white = '#FFFFFF';
    const black = '#000000';
    return [mix(hex, white, 0.92), mix(hex, white, 0.82), mix(hex, white, 0.64), mix(hex, white, 0.46), mix(hex, white, 0.3), mix(hex, white, 0.15), hex.toUpperCase(), mix(hex, black, 0.15), mix(hex, black, 0.3), mix(hex, black, 0.45)];
}
/** Relative luminance after WCAG 2.x. */
function luminance(hex) {
    const [r, g, b] = rgb(hex).map((v) => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
/** Contrast ratio after WCAG 2.x, e.g. 8.8 for white on Pflaume. */
export function contrast(a, b) {
    const [x, y] = [luminance(a), luminance(b)].sort((p, q) => q - p);
    return (x + 0.05) / (y + 0.05);
}
/** A ratio as Germans write it: 4,5 : 1. */
export const ratioText = (r) => `${r.toFixed(1).replace('.', ',')} : 1`;
/** Readability checks for the settings page: text on the background, white on the main colour. */
export function themeWarnings(t) {
    const out = [];
    if (contrast(t.text, t.background) < 4.5)
        out.push(`Text auf Hintergrund hat nur ${ratioText(contrast(t.text, t.background))} Kontrast (mindestens 4,5 : 1).`);
    if (contrast('#FFFFFF', t.primary) < 4.5)
        out.push(`Weiße Schrift auf der Hauptfarbe hat nur ${ratioText(contrast('#FFFFFF', t.primary))} Kontrast (Knöpfe, Excel-Kopfzeilen).`);
    if (contrast(t.primary, t.background) < 3)
        out.push(`Die Hauptfarbe hebt sich vom Hintergrund kaum ab (${ratioText(contrast(t.primary, t.background))}).`);
    return out;
}
//# sourceMappingURL=theme.js.map